import { trace } from 'owa-trace';
import getProfileStore from '../store/profileStore';
import type { AccountSource } from 'owa-graph-schema';

export function getAccountSourceById(sourceId: string): AccountSource | undefined {
    const accountSourcesFiltered = getProfileStore().accountSources.filter(
        source => source.id === sourceId
    );

    if (accountSourcesFiltered.length === 1) {
        return accountSourcesFiltered[0];
    }

    if (accountSourcesFiltered.length > 1) {
        trace.warn('Found more than one account with the same source id');
    }

    return undefined;
}
